import React, {useState} from 'react'
import Text from 'react-text'
import {Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import {faCaretDown} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {Consumer} from '../../../../context'

import './menu.styl'

const menuButtonStyles = makeStyles({
  root: {
    color: '#6679ad',
    background: '#f0f7ff',
    textTransform: 'none',
    border: 'solid 1px #a3b6d9',
    boxShadow: 'none',
    '&:hover': {
      background: '#eaf5ff'
    }
  }
})

const menuStyles = makeStyles ({
  root: {
    background: '#eaf5ff',
    padding: '0 8px'
  }
})

const itemStyles = makeStyles({
  root: {
    minWidth: '244px',
    maxWidth: '244px',
    display: 'flex',
    color: '#4e576e'
  }
})

export default function TemplatesMenu(props) {

  const menuButtonClasses = menuButtonStyles()
  const menuClasses = menuStyles()
  const itemClasses = itemStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)

  function handleClick(event) {
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (<Consumer>{context => {
    return (
      <div className="resources-menu" style={{width: '100%'}}>
        <Button
          aria-controls="customized-menu"
          aria-haspopup="true"
          variant="contained"
          classes={menuButtonClasses}
          onClick={handleClick}
          sx={{width: '100%'}}
        >
          <div className="plus-icon">+</div>
          <span className="label">
            <Text id="add-resources" />
          </span>
          <div className="arrow">
            <FontAwesomeIcon icon={faCaretDown} />
          </div>
        </Button>
        <Menu
          elevation={0}
          getContentAnchorEl={null}
          anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
          transformOrigin={{vertical: 'top', horizontal: 'left'}}
          id="add-resource-menu"
          anchorEl={anchorEl}
          MenuListProps={{
            disablePadding: true,
            classes: menuClasses
          }}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem disableGutters={true} classes={itemClasses}>
            <Link className="add-link-button" to={context.link({section: 'add-link-resource'},context.match.path,{preserveQuery: true})}>
              <Text id="link" />
            </Link>
          </MenuItem>
        </Menu>
      </div>
    )
  }}</Consumer>)
}
